import UserProfile from "../../components/auth/UserProfile";
import Session from "../../components/interview/Session";

const InterviewSessions = () => {
  return (
    <div className="interview-sessions-page h-screen flex flex-col">
      {/* Sticky Headers Container */}
      <div className="sticky top-0 z-50 overflow-visible">
        {/* Row 1: Logo Header */}
        <header
          className="px-6 lg:px-[120px] py-4"
          style={{
            height: "82px",
            borderBottom: "0.5px solid var(--color-beige, #EEEDEC)",
            background: "#FFF",
          }}
        >
          <img
            src="/images/mic-logo.png"
            alt="MIC Logo"
            className="h-full object-contain"
          />
        </header>

        {/* Row 2: HR Portal Title & User Profile */}
        <div
          className="px-6 lg:px-[120px] py-4"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "0.5px solid var(--color-beige, #EEEDEC)",
            background: "#FFF",
            boxShadow: "0 4px 24px 0 rgba(0, 0, 0, 0.08)"
            // clipPath: "inset(0 -24px -24px -24px)",
          }}
        >
          <div>
            {/* Column 1: HR Portal Label */}
            <div
              style={{
                background: "linear-gradient(90deg, var(--color-indigoBlue, #171C27) 0%, var(--color-turquoise, #24AEA8) 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontFamily: "Interstate",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "normal",
                letterSpacing: "4px",
              }}
            >
              ALIA
            </div>
            <div
              style={{
                color: "rgba(99, 97, 92, 0.50)",
                fontFamily: "Interstate",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 300,
                lineHeight: "20px",
              }}
            >
              AI Solutions for Talent Management
            </div>
          </div>

          {/* Column 2: User Profile */}
          <UserProfile />
        </div>
      </div>

      {/* Scrollable Content Area */}
      <div
        className="flex-1 overflow-y-auto flex flex-col"
        style={{
          background: "#FBFBFB",
        }}
      >
        {/* Row 3: Session Component */}
        <div className="flex-1">
          <Session />
        </div>

        {/* Row 4: Footer */}
        <footer
          className="px-6 lg:px-[120px] py-6"
          style={{
            height: "80px",
            minHeight: "80px",
            borderTop: "1px solid #E5E7EB",
            color: "#9CA3AF",
            fontFamily: "Interstate",
            fontSize: "12.014px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "16px",
          }}
        >
          © {new Date().getFullYear()} Mubadala Investment Company. Internal use only.
        </footer>
      </div>
    </div>
  );
};

export default InterviewSessions;
